import * as z from "zod";
import { SectionType } from "../enums/database-enums";
import { BuyBoxDraftSchema } from "../buy-boxes";
import { StorefrontSectionTranslationsSchema } from "../primitives/section-translations";

export const StorefrontPageSectionDataSchema = z.object({
  isProductPage: z.boolean().optional(),
  variant: z.string().optional(),
  sectionSelector: z.string().nullish(),
  templateId: z.number().optional(),
  targetStaticId: z.string().optional(),
  buyBoxMeta: z
    .object({
      productExternalId: z.string(),
    })
    .optional(),
  buyBoxDraft: BuyBoxDraftSchema.optional(),
});

export type StorefrontPageSectionData = z.infer<typeof StorefrontPageSectionDataSchema>;

export const StorefrontSectionTypeSchema = z.enum(SectionType);

export type StorefrontSectionType = z.infer<typeof StorefrontSectionTypeSchema>;

export const StorefrontPageSectionHiddenOnSchema = z.object({
  mobile: z.boolean().optional(),
  desktop: z.boolean().optional(),
});

export type StorefrontPageSectionHiddenOn = z.infer<typeof StorefrontPageSectionHiddenOnSchema>;

export const StorefrontPageSectionSchemaWithoutId = z.object({
  type: StorefrontSectionTypeSchema,
  displayTitle: z.string().nullish(),
  handle: z.string().nullish().describe("a handle to differentiate between section types that have the same name"),
  order: z.number(),
  hiddenOn: z.optional(StorefrontPageSectionHiddenOnSchema).optional(),
  templateId: z.number().nullish(),
  data: z.any().nullish(),
  desktopData: z.any().optional(),
  translations: StorefrontSectionTranslationsSchema.optional(),
});

export type StorefrontPageSectionWithoutId = z.infer<typeof StorefrontPageSectionSchemaWithoutId>;

export const StorefrontPageSectionSchema = StorefrontPageSectionSchemaWithoutId.extend({
  id: z.number(),
});

export type StorefrontPageSection = z.infer<typeof StorefrontPageSectionSchema>;

export type StorefrontPageSectionType = z.infer<typeof StorefrontPageSectionSchema>["type"];
